import { render, staticRenderFns } from "./VeroColumn.vue?vue&type=template&id=0b7d7561&scoped=true&"
import script from "./VeroColumn.vue?vue&type=script&lang=js&"
export * from "./VeroColumn.vue?vue&type=script&lang=js&"
import style0 from "./VeroColumn.vue?vue&type=style&index=0&id=0b7d7561&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7d7561",
  null
  
)

export default component.exports